function addPerformanceMark(label) {
  window.performance.mark(label);
}
function measurePerformanceMark(measureName, startMark, endMark) {
  try {
    if (!endMark) {
      const measure2 = window.performance.measure(measureName, startMark);
      return fallbackMeasure(measure2, measureName);
    }
    const measure = window.performance.measure(measureName, startMark, endMark);
    return fallbackMeasure(measure, measureName);
  } catch (error) {
    console.warn("Failed to measure performance", error);
    return void 0;
  }
}
function fallbackMeasure(measure, measureName) {
  if (!measure) {
    const fallback = window.performance.getEntriesByName(measureName)[0];
    return fallback.duration ?? 1e3;
  } else {
    return measure.duration;
  }
}
export {
  addPerformanceMark,
  measurePerformanceMark
};
